import { Accordion, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './styles.css';
import { IAccordionsBlockProps } from './types';

export const AccordionsBlock: React.FC<IAccordionsBlockProps> = ({ title, elements }) => {
  return (
    <div className={styles['root']}>
      <UIHeading2>{title}</UIHeading2>
      <Accordion
        autoScrollToLastActive
        items={elements.map(item => {
          return {
            title: item.title,
            content: item.content,
          };
        })}
        size="XS"
        testId="accordion"
      />
    </div>
  );
};
